<template>
  <section class="section section-shaped section-lg my-0">
    <div class="shape shape-style-1 bg-gradient-default">
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
    </div>
    <div class="container pt-lg-md">
      <div class="row justify-content-center">
        <div class="col-lg-5">
          <card type="secondary" shadow
                header-classes="bg-white pb-5"
                body-classes="px-lg-5 py-lg-5"
                class="border-0">
            <template>
              <div v-if="login_errado" class="alert alert-danger" role="alert">
                Número de inscrição ou CPF inválido.
              </div>
              <div class="text-muted text-center mb-3">
                <small>Entre com:</small>
              </div>
              <div class="btn-wrapper text-center">
              </div>
            </template>
            <template>
              <form @submit.prevent="envia_login" role="form">
                <base-input v-model="username" alternative
                            class="mb-3"
                            v-mask="'#######-#'"
                            placeholder="Número de inscrição"
                            addon-left-icon="ni ni-single-02">
                </base-input>
                <base-input v-mask="'###.###.###-##'" v-model="password" alternative

                            placeholder="CPF"
                            addon-left-icon="ni ni-badge">
                </base-input>

                <div class="text-center">
                  <base-button native-type="submit" type="primary" class="my-4">Entrar</base-button>
                </div>
              </form>
            </template>
          </card>
          <div class="row mt-3">
            <div class="col-6">
              <a href="#" class="text-light">
                <!--                <small>Esqueci minha senha</small>-->
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import axios from 'axios';
import {useRouter} from 'vue-router';
import Vue from 'vue'
import vueCrypt from 'vue-crypt'
import {cpf} from "cpf-cnpj-validator";

export default {
  name: 'Login',
  data() {
    return {
      username: '',
      password: '',
      login_errado: false,
      logins: [{cpf: 321., num_cand: 123}]
    }
  },
  methods: {
    envia_login: async function () {

      const encryptedText = this.CryptoJS.AES.encrypt("Hi There!", 'secret key 123').toString()
      const decryptedText = this.CryptoJS.AES.decrypt('U2FsdGVkX1+rGzJrqd1xvB4s0Sxxmcl9dbo4sUwcMsE=', 'secret key 123').toString(this.CryptoJS.enc.Utf8)

      const encrypt = (texto) => {
        return this.CryptoJS.AES.encrypt(texto, 'yqKdRqWEAywufSJCZpvPUF5e929UKqMh5eh7AMP5Xpv2FrmdpFeSsnVkyTGvrhPRUG48tZtn32sEGz2R8tDrGcR6wTyYwhdCEvZxbdW42SYpKF7HvrW2XK6zjuWX9946tTx5RhycNDEW8uS475mRVNASZ4CW4v4RhBS5SYHCNHc6DjpwpzWcwuMvTQzCBzMtGbXF8ud4qXhcXnwAQ3xef2tQz3ZeBjvhu32zNGY5PXem92HX3MLRhuw78TqUVsUT').toString()
      }
      const decrypt = (texto) => {
        return this.CryptoJS.AES.decrypt(texto, 'yqKdRqWEAywufSJCZpvPUF5e929UKqMh5eh7AMP5Xpv2FrmdpFeSsnVkyTGvrhPRUG48tZtn32sEGz2R8tDrGcR6wTyYwhdCEvZxbdW42SYpKF7HvrW2XK6zjuWX9946tTx5RhycNDEW8uS475mRVNASZ4CW4v4RhBS5SYHCNHc6DjpwpzWcwuMvTQzCBzMtGbXF8ud4qXhcXnwAQ3xef2tQz3ZeBjvhu32zNGY5PXem92HX3MLRhuw78TqUVsUT').toString(this.CryptoJS.enc.Utf8);
      }

      const gera_file_name = (cpf, num_cand) => {

        let candidato = {CPF: cpf, NUMEROINSC: num_cand}
        let cod_projeto = '2106_pt'
        let codigo_meio = candidato.CPF.replace(/\./g, '').replace('-', '') * 7919;
        codigo_meio = codigo_meio.toString()

        let codigo_arquivo = parseInt(codigo_meio.substring(0, 5)) * parseInt(candidato.NUMEROINSC.replace('-', '')) * 13 + '_'
            + String.fromCharCode(65 + parseInt(codigo_meio[3]))
            + String.fromCharCode(parseInt(codigo_meio[1] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[1]))
            + String.fromCharCode(parseInt(codigo_meio[4] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[5]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[2]))
            + String.fromCharCode(parseInt(codigo_meio[7] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[7]))
            + '-'
            + String.fromCharCode(parseInt(codigo_meio[0] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[11]))
            + String.fromCharCode(parseInt(codigo_meio[1] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[9]))
            + String.fromCharCode(parseInt(codigo_meio[5] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[4]))
            + String.fromCharCode(parseInt(codigo_meio[8] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[5]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[8]))
            + '_'
            + String.fromCharCode(parseInt(codigo_meio[2] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[3]))
            + String.fromCharCode(parseInt(codigo_meio[8] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[4]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[6]))
            + String.fromCharCode(parseInt(codigo_meio[6] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[2]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[11]))
            + String.fromCharCode(parseInt(codigo_meio[8] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[9]))

        return codigo_arquivo + '.pdf';
      }


      let cands =[{"num_cand":"U2FsdGVkX194Y+U8yM9n9gsbhpmlChQsxCFa2cOp7z4=","cpf":"U2FsdGVkX1/QTFm1HyyBClQH1jgWLVetW+TO23tWkL4="},{"num_cand":"U2FsdGVkX1+l923uMmPErFt7FA8Kbd151A5cXX22l4M=","cpf":"U2FsdGVkX1+jogSP0/GK2MBcdGY3xTHeVFUXJxE9CMY="},{"num_cand":"U2FsdGVkX1/9Dv4fkzOmDkx/qjsJhHpJ7gD1L8i60NQ=","cpf":"U2FsdGVkX190xd4dCO2C4s3RarStydjyxPO/phRz5e4="},{"num_cand":"U2FsdGVkX1+9xkr0Tp8UajjLmOvWuGACDbLR5gJ5N+I=","cpf":"U2FsdGVkX181/9eTe3wWLyGFnqNIyirZIa1jCZb3RFA="},{"num_cand":"U2FsdGVkX19WDixFsBZSykjRaGlYG1tkjRfU4JwI+mA=","cpf":"U2FsdGVkX1+CSq1jATGjsEcKg8W6aYnCBLVw82by0fc="},{"num_cand":"U2FsdGVkX1+2cd9NvieaV98llabY4aBgJnIIHNXWV7o=","cpf":"U2FsdGVkX1+ErThKPjvOsgYiiQHSwBujxIUQiOczjrE="},{"num_cand":"U2FsdGVkX18eVBHiQuP31xc1S/U1NYgSSfUNnTBzLfA=","cpf":"U2FsdGVkX19EZqfmpBWMqL8qsk3igdwaimA74HfPCsQ="},{"num_cand":"U2FsdGVkX1+k9aE/FtIg9B+Yd0bNHY9TwBfjLAKtI9w=","cpf":"U2FsdGVkX18LJkV6lJjt4Wq/1uaOQ5vUT31z++bZ4cI="},{"num_cand":"U2FsdGVkX180YgwczJzhXGVusok57hredRYBQf44534=","cpf":"U2FsdGVkX1/y/EdOalQ8Ew/OBRPeyYqsRfsrWVun0nc="},{"num_cand":"U2FsdGVkX19blfUFCDySA2CYjZpeyEYqYQ7EEWVm46Q=","cpf":"U2FsdGVkX18UMrmwDadGaZQnK+4n/mp/FVumTatgzVI="},{"num_cand":"U2FsdGVkX1/iGUHdLOazIK+QJYMnXR9uial+PRSM3Rk=","cpf":"U2FsdGVkX19KgVB6RNOVfTICRy0tvZmEr4Qx/dm+FTg="},{"num_cand":"U2FsdGVkX19+8TcG2q5OGUxrtF8fULMI3SLiTHFIwgU=","cpf":"U2FsdGVkX1/crHI4aauK/17gXqKf6NMs1NegzzddTWQ="},{"num_cand":"U2FsdGVkX1832elQvqbeu7RffvaIu5rDWUnxMCdSgXQ=","cpf":"U2FsdGVkX18PhE+BtInikJECu0BCY1M0NHXWbOfUMoY="},{"num_cand":"U2FsdGVkX1/tfrysJrH4sN18x/1SXqXJ05awCxqDmL8=","cpf":"U2FsdGVkX1+UqVAQ3+9N/uW3qLSUrBXE0HdvSWfXnhM="},{"num_cand":"U2FsdGVkX19naj0dhOVFV1EUAjVbmK3phsiikAXUNqc=","cpf":"U2FsdGVkX1+4dMuQ9l5nr6p569+wGFrZzf8gTGoPkf8="},{"num_cand":"U2FsdGVkX18uh8T+Q5lOAcb634tNCEd5N2Na2HyyNlw=","cpf":"U2FsdGVkX1/omXJ8SjAiJFJ2CIUDDEOh0V4198unK/o="},{"num_cand":"U2FsdGVkX1/bNZD6g7YqmdPJ+2IGrfMazOCiEyTUzK8=","cpf":"U2FsdGVkX1/LIGxgOZU9sho5yq0pj4PqFO4jfsbCXos="},{"num_cand":"U2FsdGVkX19PGNJZSthCdU7ccOCfOCFxFFZsJIxKKu8=","cpf":"U2FsdGVkX1+D+ounKIjbAGP+DkpLgaG46sp2zggqdzg="},{"num_cand":"U2FsdGVkX188RUTS68g5jH3sIS4jRlQBzQLU1Zm5jW8=","cpf":"U2FsdGVkX1/HoqnDKFcLfVTDWth2AH5rTkyl2pClH8g="},{"num_cand":"U2FsdGVkX1+kMd3D581eoPDoGyRh4ZSEjRbhajUJ2Io=","cpf":"U2FsdGVkX19gO3pzF4+QhgZb9YPWClP229buN/QDOnE="},{"num_cand":"U2FsdGVkX1/DYDwai8mMtC2GLl2I76ZuhK8n0klRaN4=","cpf":"U2FsdGVkX18lxIspEDXphSIIhO6+5HvcYbRAkAO5l9I="},{"num_cand":"U2FsdGVkX193n4EydxptN5ojKF7Erjv5r9VjWMY+Iqc=","cpf":"U2FsdGVkX1+3E6XODjKLxTZSoCHfyiVAtMw5VaEEGLg="},{"num_cand":"U2FsdGVkX19sgxMGGAPdKsyvnXzE/amABYKrcKi+83U=","cpf":"U2FsdGVkX1+0GqhzHa70m3IcDus0cf04VKnJf7TYfeg="},{"num_cand":"U2FsdGVkX18IA7tgAc+HKazXao/NSzGA/8MFqxZHWOo=","cpf":"U2FsdGVkX1/GO/ETgvAA78ny0xJdA+JP+DmifACm4UQ="},{"num_cand":"U2FsdGVkX1+mM384bDrarx9/QZsd19fdkdshKAzKb8o=","cpf":"U2FsdGVkX1/wcEVC6tZQL20qFOfJHNel/2UsPQQr2JY="},{"num_cand":"U2FsdGVkX19Q1CxI/M21ip9sp2iIdwNut+IIWj3iG84=","cpf":"U2FsdGVkX19ThMI+ihfG1pNY7XaSwjm5DSkDg5MKbCo="},{"num_cand":"U2FsdGVkX19RDHiYbr5Xk5UYLewWtRLwRBq8rY97lb0=","cpf":"U2FsdGVkX1/3Gds3PuauGgyLNeDwn29R02v/klMZKA0="},{"num_cand":"U2FsdGVkX1/gO1KqmHbhoUD0qZ47bfp+mfrZ997s/UY=","cpf":"U2FsdGVkX1/yfb7psdZmaPNd3lrGM/PzBqswtX8fq5U="},{"num_cand":"U2FsdGVkX1+7kSidfgDLjSULaaRBFZBfP6oQRhFQXsU=","cpf":"U2FsdGVkX1/yIT0Ahp6kdXcJ/GfsZATGM2OklHlVfe0="},{"num_cand":"U2FsdGVkX18oXv+pSBKXWE86LMwuhUuJP5pqqHU795U=","cpf":"U2FsdGVkX1+9dnFUMCKX2M3hyLja80qW5mwPGqThy3I="},{"num_cand":"U2FsdGVkX1+jq8ZV4sVVT5bYsk+DOe7w+SsqyKWTmZM=","cpf":"U2FsdGVkX1/QZ8TPWf9jtUWpI3FJAhCrohErkL5rpsU="},{"num_cand":"U2FsdGVkX19NeU16BqZshEP7e/5VGi6r0r4l+Wi3zpU=","cpf":"U2FsdGVkX1/HT9FN5zpgw/5QWEniruKo9ynUaOkv9lI="},{"num_cand":"U2FsdGVkX1+ZqXN8mjCfirMwpY0cT7chxWVpep7Bc2M=","cpf":"U2FsdGVkX1/wP+Ld9QIb0DKjDAvFvFO6xi5C+xbKJfI="},{"num_cand":"U2FsdGVkX18BFDH59Ct6kaF6WNjzx4mDrV/TMIl5AiA=","cpf":"U2FsdGVkX19uEazCbEcEWMT004HvvjIv3CHIf0xvp2s="},{"num_cand":"U2FsdGVkX1+NVQYrPQw5Y8zjqHDr1lqVY4oK4/PWur8=","cpf":"U2FsdGVkX18wsbbD0pTPGc3L8YhpqvnDPTHjAgXukEQ="}]


      try {
        let concurso = this.$route.params.concurso;
        localStorage.setItem('concurso', concurso);

        for (let login of cands) {
          let num_cand_decripted = decrypt(login.num_cand);
          let cpf_decripted = decrypt(login.cpf);

          // console.log(num_cand_decripted,cpf_decripted)
          if (num_cand_decripted == this.username && cpf_decripted == this.password) {
            console.log(`Logged`)
            let nome_arquivo = (gera_file_name(cpf_decripted, num_cand_decripted))
            nome_arquivo = nome_arquivo.replace(/\x00/g, '-');


            // alert(`Logou`);
            let url = (`https://fs.ibfc.org.br/arquivos/2211/res_po_del/${nome_arquivo}`)
            return window.location = url;
          }
        }

        throw new Error(`Login inválido`);


      } catch (error) {
        console.log(error);
        this.login_errado = true;
      }
    }
  }
};
</script>
<style>
</style>
